import React from 'react';
import { useSkipLinks } from '../hooks/useKeyboardNavigation';

const SkipLinks: React.FC = () => {
  const { skipToContent, skipToNavigation } = useSkipLinks();

  return (
    <div className="sr-only focus-within:not-sr-only">
      <div className="fixed top-0 left-0 z-50 bg-blue-600 text-white p-2 rounded-br-md">
        <button
          onClick={skipToContent}
          className="mr-4 px-3 py-2 bg-blue-700 hover:bg-blue-800 rounded focus:outline-none focus:ring-2 focus:ring-white"
        >
          Skip to main content
        </button>
        <button
          onClick={skipToNavigation}
          className="px-3 py-2 bg-blue-700 hover:bg-blue-800 rounded focus:outline-none focus:ring-2 focus:ring-white"
        >
          Skip to navigation
        </button>
      </div>
    </div>
  );
};

export default SkipLinks;